<template>
  <span>
    <span>{{ item.getText() }}</span>
    <span class="secondary" v-if="item.type === 'date'">
      {{ item.getSecondaryText() }}
    </span>
    <span v-if="item.isShared()" class="md-icon indicator">people</span>
    <span v-if="item.repeat" class="md-icon indicator">refresh</span>
    <div v-if="isPlanned" class="dateChip">
      <div class="md-icon">{{ dateInfo.icon }}</div>
      <div class="text">{{ dateInfo.text }}</div>
    </div>
    <div v-for="label in labels" class="labelChip">
      <div class="text">{{ label.getText() }}</div>
    </div>
  </span>
</template>

<style scoped>
.indicator.md-icon {
  margin-left: 0.25em;
  align-items: center;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
  opacity: 60%;
  width: 20px;
  height: 18px;
  min-width: 20px;
  min-height: 18px;
  font-size: 21px !important;
}
.indicator {
  margin-left: 0.25em;
  align-items: center;
  opacity: 60%;
  font-size: 85%;
  display: inline-block;
}

.dateChip {
  opacity: var(--text-opacity-tertiary);
  display: inline-flex;
  gap: 2px;
  align-items: center;
  background: var(--bg-color-list);
  padding: 2px 4px;
  vertical-align: middle;
  border-radius: 4px;
  margin-left: 4px;
}
.labelChip {
  opacity: var(--text-opacity-tertiary);
  display: inline-flex;
  gap: 2px;
  align-items: center;
  background: var(--accent-color-l80);
  padding: 2px 4px;
  vertical-align: middle;
  border-radius: 4px;
  margin-left: 4px;
}
.dateChip .md-icon {
  font-size: 16px;
}
.dateChip .text {
  font-size: var(--text-size-secondary);
}

.timeRelation .dateChip {
  display: none;
}

.timeRelation .elements .dateChip {
  display: inline-flex;
}

span {
  white-space: pre-wrap;
}

.item-name .secondary {
  opacity: var(--text-opacity-tertiary);
}
.no-secondary .secondary {
  display: none;
}

.isDone .item-name span {
  opacity: var(--text-opacity-secondary);
  text-decoration: line-through;
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import { REL_LABL, REL_PLAN } from "@/structure";
import { formatDateItem } from "@/time-utils";

export default {
  name: "ItemHeader",
  props: ["item"],
  data() {
    return {};
  },
  computed: {
    isPlanned() {
      return this.item[REL_PLAN] && this.item.getParent(REL_PLAN);
    },
    dateInfo() {
      const parent = this.item.getParent(REL_PLAN);
      // TODO: to wygląda źle
      if (!parent) return {}; // in case period was deleted etc.
      return {
        icon: parent.getIcon(),
        text: formatDateItem(parent),
      };
    },
    labels() {
      return (Object.keys(this.item[REL_LABL] || {})).map((id) => getItem(id));
    },
  },
  methods: {},
};
</script>
